var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "address-content" },
    [
      _c(
        "div",
        { staticClass: "selection", on: { click: _vm.toogleAddressSelection } },
        [
          _c(
            "span",
            {
              staticClass: "header",
              class: { "header-selected": _vm.address }
            },
            [_vm._v("Endereço")]
          ),
          _vm._v(" "),
          !_vm.address
            ? _c("span", { staticClass: "detail" }, [
                _vm._v("Onde você precisa de limpeza?")
              ])
            : _c("SelectedAddress", { attrs: { address: _vm.address } })
        ],
        1
      ),
      _vm._v(" "),
      _vm.open && _vm.searchOrderOfferProfessionals
        ? _c("CancelOrderOffer", {
            on: {
              closeCancelOrderOfferModal: _vm.toogleAddressSelection,
              cancelOrderOffer: _vm.handleCancelOrderOffer
            }
          })
        : _vm.open
          ? _c("Addresses", {
              on: { addressSelection: _vm.toogleAddressSelection }
            })
          : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8db7973c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8db7973c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/Address/Index.vue
// module id = null
// module chunks = 